import { TextFieldSkeleton } from 'shared/ui/form-elements';
import { ButtonSkeleton } from 'shared/ui/button';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import mergeClasses from 'shared/lib/utils';
export const configVariants = cva('grid grid-cols-1 gap-2', {
  variants: {
    variant: {
      default: 'lg:grid-cols-2',
      model: 'mb-2'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
export const fieldVariants = cva('grid grid-cols-1 divide-separator', {
  variants: {
    fields: {
      default: 'divide-y lg:divide-y-0',
      model: 'divide-y'
    }
  },
  defaultVariants: {
    fields: 'default'
  }
});
interface SkeletonConfigProps extends VariantProps<typeof configVariants> {}
export const SkeletonConfig = ({
  variant
}: SkeletonConfigProps) => {
  return <div className="w-full" data-sentry-component="SkeletonConfig" data-sentry-source-file="skeleton-config.tsx">
      <div className="max-w-2xl">
        <div className={mergeClasses(configVariants({
        variant
      }), 'mb-5')}>
          <TextFieldSkeleton variant="dark" data-sentry-element="TextFieldSkeleton" data-sentry-source-file="skeleton-config.tsx" />
          <TextFieldSkeleton variant="dark" data-sentry-element="TextFieldSkeleton" data-sentry-source-file="skeleton-config.tsx" />
          <div className="mt-5 grid grid-cols-1">
            <TextFieldSkeleton variant="dark" data-sentry-element="TextFieldSkeleton" data-sentry-source-file="skeleton-config.tsx" />
            <TextFieldSkeleton variant="dark" data-sentry-element="TextFieldSkeleton" data-sentry-source-file="skeleton-config.tsx" />
            <TextFieldSkeleton variant="dark" data-sentry-element="TextFieldSkeleton" data-sentry-source-file="skeleton-config.tsx" />
            <TextFieldSkeleton variant="dark" data-sentry-element="TextFieldSkeleton" data-sentry-source-file="skeleton-config.tsx" />
          </div>
        </div>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2 ">
          <div className="flex w-full flex-col flex-wrap md:flex-row">
            <ButtonSkeleton variant="dark" data-sentry-element="ButtonSkeleton" data-sentry-source-file="skeleton-config.tsx" />
          </div>
          <div className="flex w-full flex-col md:flex-row md:justify-end">
            <ButtonSkeleton variant="dark" data-sentry-element="ButtonSkeleton" data-sentry-source-file="skeleton-config.tsx" />
          </div>
        </div>
      </div>
    </div>;
};